import React from 'react';
import { Tag } from 'antd';
import {
  FEEDBACK_REPORT_OPTION_LABELS,
  FeedbackReportPriority,
  FeedbackReportStatus,
} from '@wellverse/shared-ts';

/** English label for a fixed option ID; unknown IDs show as-is. */
export const optionLabel = (id?: string | null): string =>
  id ? FEEDBACK_REPORT_OPTION_LABELS[id] ?? id : '—';

export const PRIORITY_OPTIONS: FeedbackReportPriority[] = ['P0', 'P1', 'P2', 'P3'];

export const STATUS_OPTIONS: { value: FeedbackReportStatus; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'fixed', label: 'Fixed' },
  { value: 'wont_fix', label: "Won't fix" },
  { value: 'duplicate', label: 'Duplicate' },
];

const priorityColors: Record<FeedbackReportPriority, string> = {
  P0: 'red',
  P1: 'volcano',
  P2: 'gold',
  P3: 'default',
};

export const PriorityTag: React.FC<{ priority: FeedbackReportPriority }> = ({ priority }) => (
  <Tag color={priorityColors[priority]}>{priority}</Tag>
);

export const statusLabel = (status: FeedbackReportStatus): string =>
  STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;
